export default "__VITE_ASSET__e5f98903__"